import { WX_ID_GFS } from "../../../store/WeatherContentsState";
import GfsUpper from "./GfsUpper";
import GfsGround from "./GfsGround";
import { _orderBy, calcPressureFromAlt, ft2m, translation } from "../../../utils/FPEUtils";
import LegendGfs from "../legend/LegendGfs";
import TimeController from "../helper/TimeController";
import Mutex from "../../../utils/Mutex";
import LegendGfsSub from "../legend/LegendGfsSub";

class Gfs {
  static NAME = WX_ID_GFS;
  static GFS_GROUND = `${Gfs.NAME}_Ground`;
  static GFS_UPPER = `${Gfs.NAME}_Upper`;
  static WIND_ARROW_NAME = `${Gfs.NAME}_WIND_ARROW`;
  static WIND_STREAM_NAME = `${Gfs.NAME}_WIND_STREAM`;
  static ISOTACH_CONTOUR_NAME = `${Gfs.NAME}_ISOTACH_CONTOUR`;
  static ISOTACH_GRADATION_NAME = `${Gfs.NAME}_ISOTACH_GRADATION`;
  static ISOTHERM_CONTOUR_NAME = `${Gfs.NAME}_ISOTHERM_CONTOUR`;
  static ISOTHERM_GRADATION_NAME = `${Gfs.NAME}_ISOTHERM_GRADATION`;
  static ISOTHERM_GRID_NAME = `${Gfs.NAME}_ISOTHERM_VALUE`;
  static GEO_POTENTIAL_HEIGHT_NAME = `${Gfs.NAME}_GEO_POTENTIAL_HEIGHT`;
  static ICING_PROB_NAME = `${Gfs.NAME}_ICING_PROB_NAME`;
  static PRECIPITATION_1H_MESH_NAME = `${Gfs.NAME}_PRECIPITATION_1H_MESH`;
  static PRECIPITATION_1H_CONTOUR_NAME = `${Gfs.NAME}_PRECIPITATION_1H_CONTOUR`;
  static PRECIPITATION_1H_GRID_NAME = `${Gfs.NAME}_PRECIPITATION_1H_GRID`;
  static RELATIVE_HUMIDITY_CONTOUR_NAME = `${Gfs.NAME}_RELATIVE_HUMIDITY_CONTOUR_NAME`;
  static RELATIVE_HUMIDITY_GRADATION_NAME = `${Gfs.NAME}_RELATIVE_HUMIDITY_GRADATION_NAME`;
  static PRESSUREMSL_CONTOUR_NAME = `${Gfs.NAME}_PRESSUREMSL_CONTOUR_NAME`;
  static PRESSUREMSL_HI_LO_NAME = `${Gfs.NAME}_PRESSUREMSL_HI_LO_NAME`;
  static VISIBILITY_CONTOUR_NAME = `${Gfs.NAME}_VISIBILITY_CONTOUR_NAME`;
  static VISIBILITY_GRADATION_NAME = `${Gfs.NAME}_VISIBILITY_GRADATION_NAME`;
  static LOW_CLOUD_COVER_CONTOUR_NAME = `${Gfs.NAME}_LOW_CLOUD_COVER_CONTOUR_NAME`;
  static LOW_CLOUD_COVER_GRADATION_NAME = `${Gfs.NAME}_LOW_CLOUD_COVER_GRADATION_NAME`;
  static MEDIUM_CLOUD_COVER_CONTOUR_NAME = `${Gfs.NAME}_MEDIUM_CLOUD_COVER_CONTOUR_NAME`;
  static MEDIUM_CLOUD_COVER_GRADATION_NAME = `${Gfs.NAME}_MEDIUM_CLOUD_COVER_GRADATION_NAME`;
  static HIGH_CLOUD_COVER_CONTOUR_NAME = `${Gfs.NAME}_HIGH_CLOUD_COVER_CONTOUR_NAME`;
  static HIGH_CLOUD_COVER_GRADATION_NAME = `${Gfs.NAME}_HIGH_CLOUD_COVER_GRADATION_NAME`;
  static GFS_UPPER_LEVEL = {
    "100": "FL530 / 100hPa",
    "150": "FL450 / 150hPa",
    "200": "FL390 / 200hPa",
    "250": "FL340 / 250hPa",
    "300": "FL300 / 300hPa",
    "350": "FL270 / 350hPa",
    "400": "FL240 / 400hPa",
    "500": "FL180 / 500hPa",
    "550": "FL160 / 550hPa",
    "600": "FL140 / 600hPa",
    "650": "FL120 / 650hPa",
    "700": "FL100 / 700hPa",
    "750": "FL080 / 750hPa",
    "800": "FL070 / 800hPa",
    "850": "FL050 / 850hPa",
    "900": "FL030 / 900hPa",
    "925": "FL025 / 925hPa",
    "950": "FL020 / 950hPa",
    "975": "FL010 / 975hPa",
    "1000": "FL005 / 1000hPa",
  };
  static GFS_GROUND_CONTENTS_KEYS = [
    Gfs.WIND_ARROW_NAME,
    Gfs.WIND_STREAM_NAME,
    Gfs.ISOTACH_CONTOUR_NAME,
    Gfs.ISOTACH_GRADATION_NAME,
    Gfs.ISOTHERM_CONTOUR_NAME,
    Gfs.ISOTHERM_GRADATION_NAME,
    Gfs.ISOTHERM_GRID_NAME,
    Gfs.ICING_PROB_NAME,
    Gfs.PRECIPITATION_1H_MESH_NAME,
    Gfs.PRECIPITATION_1H_CONTOUR_NAME,
    Gfs.PRECIPITATION_1H_GRID_NAME,
    Gfs.RELATIVE_HUMIDITY_CONTOUR_NAME,
    Gfs.RELATIVE_HUMIDITY_GRADATION_NAME,
    Gfs.PRESSUREMSL_CONTOUR_NAME,
    Gfs.PRESSUREMSL_HI_LO_NAME,
    Gfs.VISIBILITY_CONTOUR_NAME,
    Gfs.VISIBILITY_GRADATION_NAME,
    Gfs.LOW_CLOUD_COVER_CONTOUR_NAME,
    Gfs.LOW_CLOUD_COVER_GRADATION_NAME,
    Gfs.MEDIUM_CLOUD_COVER_CONTOUR_NAME,
    Gfs.MEDIUM_CLOUD_COVER_GRADATION_NAME,
    Gfs.HIGH_CLOUD_COVER_CONTOUR_NAME,
    Gfs.HIGH_CLOUD_COVER_GRADATION_NAME,
  ];
  static GFS_UPPER_CONTENTS_KEYS = [
    Gfs.WIND_ARROW_NAME,
    Gfs.WIND_STREAM_NAME,
    Gfs.ISOTACH_CONTOUR_NAME,
    Gfs.ISOTACH_GRADATION_NAME,
    Gfs.ISOTHERM_CONTOUR_NAME,
    Gfs.ISOTHERM_GRADATION_NAME,
    Gfs.ISOTHERM_GRID_NAME,
    Gfs.ICING_PROB_NAME,
    Gfs.GEO_POTENTIAL_HEIGHT_NAME,
    Gfs.RELATIVE_HUMIDITY_CONTOUR_NAME,
    Gfs.RELATIVE_HUMIDITY_GRADATION_NAME,
  ];
  static CONTENTS_VISIBLE_STATE_DEFAULT = {
    [Gfs.WIND_ARROW_NAME]: false,
    [Gfs.WIND_STREAM_NAME]: true,
    [Gfs.ISOTACH_CONTOUR_NAME]: true,
    [Gfs.ISOTACH_GRADATION_NAME]: false,
    [Gfs.ISOTHERM_CONTOUR_NAME]: true,
    [Gfs.ISOTHERM_GRADATION_NAME]: false,
    [Gfs.ISOTHERM_GRID_NAME]: false,
    [Gfs.GEO_POTENTIAL_HEIGHT_NAME]: true,
    [Gfs.ICING_PROB_NAME]: true,
    [Gfs.PRECIPITATION_1H_MESH_NAME]: true,
    [Gfs.PRECIPITATION_1H_CONTOUR_NAME]: true,
    [Gfs.PRECIPITATION_1H_GRID_NAME]: false,
    [Gfs.RELATIVE_HUMIDITY_CONTOUR_NAME]: true,
    [Gfs.RELATIVE_HUMIDITY_GRADATION_NAME]: false,
    [Gfs.PRESSUREMSL_CONTOUR_NAME]: false,
    [Gfs.PRESSUREMSL_HI_LO_NAME]: false,
    [Gfs.VISIBILITY_CONTOUR_NAME]: false,
    [Gfs.VISIBILITY_GRADATION_NAME]: false,
    [Gfs.LOW_CLOUD_COVER_CONTOUR_NAME]: false,
    [Gfs.LOW_CLOUD_COVER_GRADATION_NAME]: false,
    [Gfs.MEDIUM_CLOUD_COVER_CONTOUR_NAME]: false,
    [Gfs.MEDIUM_CLOUD_COVER_GRADATION_NAME]: false,
    [Gfs.HIGH_CLOUD_COVER_CONTOUR_NAME]: false,
    [Gfs.HIGH_CLOUD_COVER_GRADATION_NAME]: false,
  };
  keyMap =  {
    [Gfs.WIND_ARROW_NAME]: {
      groundKey: GfsGround.WIND_ARROW_NAME,
      upperKey: GfsUpper.WIND_ARROW_NAME
    },
    [Gfs.WIND_STREAM_NAME]: {
      groundKey: GfsGround.WIND_STREAM_NAME,
      upperKey: GfsUpper.WIND_STREAM_NAME
    },
    [Gfs.ISOTACH_CONTOUR_NAME]: {
      groundKey: GfsGround.ISOTACH_CONTOUR_NAME,
      upperKey: GfsUpper.ISOTACH_CONTOUR_NAME
    },
    [Gfs.ISOTACH_GRADATION_NAME]: {
      groundKey: GfsGround.ISOTACH_GRADATION_NAME,
      upperKey: GfsUpper.ISOTACH_GRADATION_NAME
    },
    [Gfs.ISOTHERM_CONTOUR_NAME]: {
      groundKey: GfsGround.ISOTHERM_CONTOUR_NAME,
      upperKey: GfsUpper.ISOTHERM_CONTOUR_NAME
    },
    [Gfs.ISOTHERM_GRADATION_NAME]: {
      groundKey: GfsGround.ISOTHERM_GRADATION_NAME,
      upperKey: GfsUpper.ISOTHERM_GRADATION_NAME
    },
    [Gfs.ISOTHERM_GRID_NAME]: {
      groundKey: GfsGround.ISOTHERM_GRID_NAME,
      upperKey: GfsUpper.ISOTHERM_GRID_NAME
    },
    [Gfs.GEO_POTENTIAL_HEIGHT_NAME]: {
      groundKey: undefined,
      upperKey: GfsUpper.GEO_POTENTIAL_HEIGHT_NAME
    },
    [Gfs.ICING_PROB_NAME]: {
      groundKey: GfsGround.ICING_PROB_NAME,
      upperKey: GfsUpper.ICING_PROB_NAME
    },
    [Gfs.PRECIPITATION_1H_MESH_NAME]: {
      groundKey: GfsGround.PRECIPITATION_1H_MESH_NAME,
      upperKey: undefined
    },
    [Gfs.PRECIPITATION_1H_CONTOUR_NAME]: {
      groundKey: GfsGround.PRECIPITATION_1H_CONTOUR_NAME,
      upperKey: undefined
    },
    [Gfs.PRECIPITATION_1H_GRID_NAME]: {
      groundKey: GfsGround.PRECIPITATION_1H_GRID_NAME,
      upperKey: undefined
    },
    [Gfs.RELATIVE_HUMIDITY_CONTOUR_NAME]: {
      groundKey: GfsGround.RELATIVE_HUMIDITY_CONTOUR_NAME,
      upperKey: GfsUpper.RELATIVE_HUMIDITY_CONTOUR_NAME
    },
    [Gfs.RELATIVE_HUMIDITY_GRADATION_NAME]: {
      groundKey: GfsGround.RELATIVE_HUMIDITY_GRADATION_NAME,
      upperKey: GfsUpper.RELATIVE_HUMIDITY_GRADATION_NAME
    },
    [Gfs.PRESSUREMSL_CONTOUR_NAME]: {
      groundKey: GfsGround.PRESSUREMSL_CONTOUR_NAME,
      undefined
    },
    [Gfs.PRESSUREMSL_HI_LO_NAME]: {
      groundKey: GfsGround.PRESSUREMSL_HI_LO_NAME,
      undefined
    },
    [Gfs.VISIBILITY_CONTOUR_NAME]: {
      groundKey: GfsGround.VISIBILITY_CONTOUR_NAME,
      undefined
    },
    [Gfs.VISIBILITY_GRADATION_NAME]: {
      groundKey: GfsGround.VISIBILITY_GRADATION_NAME,
      undefined
    },
    [Gfs.LOW_CLOUD_COVER_CONTOUR_NAME]: {
      groundKey: GfsGround.LOW_CLOUD_COVER_CONTOUR_NAME,
      undefined
    },
    [Gfs.LOW_CLOUD_COVER_GRADATION_NAME]: {
      groundKey: GfsGround.LOW_CLOUD_COVER_GRADATION_NAME,
      undefined
    },
    [Gfs.MEDIUM_CLOUD_COVER_CONTOUR_NAME]: {
      groundKey: GfsGround.MEDIUM_CLOUD_COVER_CONTOUR_NAME,
      undefined
    },
    [Gfs.MEDIUM_CLOUD_COVER_GRADATION_NAME]: {
      groundKey: GfsGround.MEDIUM_CLOUD_COVER_GRADATION_NAME,
      undefined
    },
    [Gfs.HIGH_CLOUD_COVER_CONTOUR_NAME]: {
      groundKey: GfsGround.HIGH_CLOUD_COVER_CONTOUR_NAME,
      undefined
    },
    [Gfs.HIGH_CLOUD_COVER_GRADATION_NAME]: {
      groundKey: GfsGround.HIGH_CLOUD_COVER_GRADATION_NAME,
      undefined
    },
  };
  viewGround = true;
  altitude = 0;
  level = '0';
  contentsVisibleState = {...Gfs.CONTENTS_VISIBLE_STATE_DEFAULT};
  //GFSタイムコントローラー
  gfsTimeController;
  //タイムコントローラーのリスト
  timeList;
  //自動更新フラグ
  autoRefresh = true;

  constructor(isDark) {
    this.gfsTimeController = new TimeController(WX_ID_GFS,{
      label: 'GFS',
      getTimeList: () => {
        if (this.timeList) {
          return this.timeList;
        }
        this._updateTimeList();
        return this.timeList;
      },
      updated: () => {
        this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
      },
      changeAutoRefresh: (autoFlg) => {
        this.setAutoRefresh(autoFlg);
      }
    });
    this.gfsUpper = new GfsUpper(isDark, this.gfsTimeController);
    this.gfsGround = new GfsGround(isDark, this.gfsTimeController);
    this.gfsUpper.setUpdateTimeFunc(this._updateTimeList.bind(this));
    this.gfsGround.setUpdateTimeFunc(this._updateTimeList.bind(this));
    this.drawLayerMutex = new Mutex();
  }

  setDispatcher(dispatcher) {
    this.dispatcher = dispatcher;
    const cascade = (action) => {
      if (action.type === 'SET_CONTENTS_TIME') {
        this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
      } else {
        return this.dispatcher(action);
      }
    };
    this.gfsUpper.setDispatcher(cascade);
    this.gfsGround.setDispatcher(cascade);
  }

  setModelDispatcher(dispatcher) {
    this.modelDispatcher = dispatcher;
  }

  async drawLayer(visible) {
    this.drawLayerMutex.runExclusion(async () => {
      this.visible = visible;

      if (visible) {
        //visible = falseの切り替えから行う(TimeController絡みの最適化）
        if(this.viewGround) {
          await Promise.all([
            this.gfsUpper.drawLayer(false),
            this.gfsGround.drawLayer(true)
          ]);
        } else {
          await Promise.all([
            this.gfsGround.drawLayer(false),
            this.gfsUpper.drawLayer(true)
          ]);
        }
      } else {
        await Promise.all([
          this.gfsGround.drawLayer(false),
          this.gfsUpper.drawLayer(false)
        ]);
      }
    });
  }

  getLayer() {
    return [...this.gfsUpper.getLayer(), ...this.gfsGround.getLayer()];
  }

  getTimeInformation() {
    let info;
    if(this.viewGround) {
      info = this.gfsGround.getTimeInformation();
    } else {
      info = this.gfsUpper.getTimeInformation();
    }
    info.id = Gfs.NAME;
    return info;
  }

  getLegend() {
    return {
      id: Gfs.NAME,
      label: 'GFS',
      component: LegendGfs,
      subComponent: LegendGfsSub,
      contents: this
    };
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  getIndividualAltitude() {
    return {
      id: Gfs.NAME,
      altitude: this.altitude,
      label: 'GFS',
      tooltip: this._altitudeTooltip
    };
  }

  getAltitudeLabel() {
    return this._altitudeTooltip(this.altitude);
  }

  applyIndividualAltitude(altitude) {
    if(this.altitude !== altitude) {
      const before = this.viewGround;
      if(altitude === 0) {
        this.viewGround = true;
      } else {
        this.viewGround = false;
        this.gfsUpper.applyIndividualAltitude(altitude);
      }

      if (before !== this.viewGround) {
        this.drawLayer(this.visible);
        this._updateTimeList();
      }

      this.altitude = altitude;
    }
  }

  applyElapsed(elapsed) {
    this.gfsGround.applyElapsed(elapsed);
    this.gfsUpper.applyElapsed(elapsed);
  }

  applyPlanETD(etd) {
    this.gfsGround.applyPlanETD(etd);
    this.gfsUpper.applyPlanETD(etd);
  }

  getTimeController() {
    return this.gfsTimeController;
  }

  setAutoRefresh(autoFlg) {
    this.autoRefresh = autoFlg;
    this.gfsGround.setAutoRefresh(autoFlg);
    this.gfsUpper.setAutoRefresh(autoFlg);
  }

  _altitudeTooltip(altitude) {
    if(altitude === 0) return translation('Ground');
    const gfs = [
      {fl: 530, mb: 100},
      {fl: 450, mb: 150},
      {fl: 390, mb: 200},
      {fl: 340, mb: 250},
      {fl: 300, mb: 300},
      {fl: 270, mb: 350},
      {fl: 240, mb: 400},
      {fl: 180, mb: 500},
      {fl: 160, mb: 550},
      {fl: 140, mb: 600},
      {fl: 120, mb: 650},
      {fl: 100, mb: 700},
      {fl: 80, mb: 750},
      {fl: 70, mb: 800},
      {fl: 50, mb: 850},
      {fl: 30, mb: 900},
      {fl: 25, mb: 925},
      {fl: 20, mb: 950},
      {fl: 10, mb: 975},
      {fl: 5, mb: 1000},
    ]

    const m = ft2m(altitude * 100);
    const mb = calcPressureFromAlt(m);
    const near = _orderBy(gfs, [
      o => {
        return Math.abs(mb - o.mb);
      },
      o => {
        return o;
      }
    ])[0];
    const fl = ('000' + near.fl).slice(-3);
    return `FL${fl} / ${near.mb}hPa`;
  }

  getDataType() {
    return this.viewGround ? Gfs.GFS_GROUND : Gfs.GFS_UPPER;
  }

  getContentsKeys() {
    return this.viewGround ? Gfs.GFS_GROUND_CONTENTS_KEYS : Gfs.GFS_UPPER_CONTENTS_KEYS;
  }

  resetContentsVisibleState(csAllOff) {
    if (Object.keys(this.contentsVisibleState)
      .filter(key => this.getContentsKeys(this.getDataType()).includes(key))
      .filter(key => this.contentsVisibleState[key]).length === 0 && csAllOff) {
      this.contentsVisibleState = {...Gfs.CONTENTS_VISIBLE_STATE_DEFAULT};
      this.gfsGround.resetContentsVisibleState();
      this.gfsUpper.resetContentsVisibleState();
      return true;
    }
    return false;
  }

  applyMapColor(mapColor, isDark) {
    this.gfsGround.applyMapColor(mapColor, isDark);
    this.gfsUpper.applyMapColor(mapColor, isDark);
  }

  async setVisible(visible, contents) {
    if (this.contentsVisibleState.hasOwnProperty(contents)) {
      this.contentsVisibleState[contents] = visible;

      const key = this.keyMap[contents];
      if (key?.groundKey !== undefined) {
        this.gfsGround.setVisible(visible, key.groundKey);
      }
      if (key?.upperKey !== undefined) {
        this.gfsUpper.setVisible(visible, key.upperKey);
      }
    }
    await this.modelDispatcher({type: 'SET_MODEL_CONTENTS_VISIBLE', payload: {targetName: contents, visible}});
  }

  _updateTimeList() {
    let timelist;
    if (this.viewGround) {
      timelist = this.gfsGround?.dh?.retained?.timelist?.timelist;
    } else {
      timelist = this.gfsUpper?.dh?.retained?.timelist?.timelist;
    }

    if (!timelist) {
      return;
    }

    //最新のbasetimeのvalidtimeを取得
    const latestBasetime = _orderBy(timelist, ['basetime'], ['desc'])[0];
    if (!latestBasetime.validtime) {
      return;
    }
    this.timeList = Array.from(latestBasetime.validtime).sort();

    if (this.autoRefresh) {
      if (this.viewGround) {
        this.gfsTimeController.setCurrentTime(this.gfsGround.validTime);
      } else {
        this.gfsTimeController.setCurrentTime(this.gfsUpper.validTime);
      }
    }
    this.gfsTimeController.adjustCurrentTime();
    this.gfsTimeController.invalidate();
  }

  getLevels() {
    const labels = Object.keys(Gfs.GFS_UPPER_LEVEL)
      .sort((a,b) => { return a - b;})
      .map(value => {
        return {
          value,
          label: Gfs.GFS_UPPER_LEVEL[value]
        };
      });
    labels.push({value: "0", label: translation('Ground')});
    return labels;
  }
  async setLevel(level) {
    this.modelDispatcher({type: 'SET_MODEL_LEVEL', payload: level});

    if (this.level === level) return;
    this.level = level;
    await this.setViewGround(level === "0");
    if (level !== "0") {
      this.gfsUpper.applyIndividualLevel(level, Gfs.GFS_UPPER_LEVEL[level]);
    }
  }
  getLevel() {
    return this.level;
  }
  async setViewGround(viewGround) {
    if (this.viewGround === viewGround) return;
    this.viewGround = viewGround;
    await this.drawLayer(this.visible);
    this._updateTimeList();
  }

  isElementDisableAtLevel(element, level) {
    // 地上は高度による要素の制限はない
    if (this.viewGround) return false;

    const elementName = this.keyMap[element]?.upperKey;
    if (elementName === undefined) return true;

    return this.gfsUpper.isElementDisableAtLevel(elementName, level)
  }
}

export default Gfs;
